export const BILLING_TYPE = [
  { id: 1, name: 'Warehouse', code: 'WAREHOUSE' },
  { id: 2, name: 'Billing', code: 'BILLING' },
];
export const ADDRESS_STATUS = [
  { id: 1, name: 'Active', code: 'ACTIVE' },
  { id: 2, name: 'In-active', code: 'IN_ACTIVE' },
];
